import React from "react";
import { Link } from "react-router-dom";
import styles from "./LegalesArticle.module.css";

// Define the types for our props
interface LegalesArticleProps {
  title: string;
  content: string; // Now accepts string HTML content from Strapi
  coverImage?: string;
  date?: string | null; // Update to accept null
  duration?: string | null; // Update to accept null
  backLink?: boolean;
  onBack?: () => void;
}

const LegalesArticle: React.FC<LegalesArticleProps> = ({
  title,
  content,
  coverImage,
  date,
  duration,
  backLink = true,
  onBack,
}) => {
  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onBack) {
      onBack();
    } else {
      // Default backup behavior if no onBack handler provided
      window.history.back();
    }
  };

  console.log("LegalesArticle rendering:", {
    title,
    backLink,
    hasContent: Boolean(content),
    contentLength: content?.length || 0,
  });

  // Safety check for missing content
  if (!title) {
    return (
      <div className={styles.articleContainer}>Error al cargar el artículo</div>
    );
  }

  return (
    <div className={styles.articleContainer}>
      {backLink && (
        <Link
          to="/legales/promociones"
          className={styles.backLink}
          onClick={handleBackClick}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 12L6 8L10 4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Volver a promociones
        </Link>
      )}

      <h1 className={styles.articleTitle}>{title}</h1>

      {(coverImage || date || duration) && (
        <>
          {coverImage && (
            <img src={coverImage} alt={title} className={styles.coverImage} />
          )}
          <div className={styles.metaInfo}>
            {date && (
              <div className={styles.date}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.6667 2.66667H3.33333C2.59695 2.66667 2 3.26362 2 4.00001V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V4.00001C14 3.26362 13.403 2.66667 12.6667 2.66667Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.6667 1.33334V4.00001"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.33333 1.33334V4.00001"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 6.66667H14"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {date}
              </div>
            )}
            {duration && (
              <div className={styles.date}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 4V8L10 10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {duration}
              </div>
            )}
          </div>
        </>
      )}

      <div
        className={styles.articleContent}
        dangerouslySetInnerHTML={{
          __html:
            content || "<p>No se pudo cargar el contenido del artículo.</p>",
        }}
      />
    </div>
  );
};

export default LegalesArticle;
